export default __webpack_public_path__ + "static/media/gilets_jaunes_selfie.7a46c563.jpg";